/**
 * Small helpers for talking about characters by number.
 */

/** "U+00E9", "U+1F600": at least four hex digits, upper case, the Unicode convention. */
export function formatCodePoint(codePoint: number): string {
  return `U+${codePoint.toString(16).toUpperCase().padStart(4, "0")}`;
}

/** Controls, format characters, unassigned and private-use code points, and spaces. */
const INVISIBLE = /^[\p{C}\p{Z}]$/u;

/**
 * A character as it can be shown in a sentence: itself when it has a visible glyph,
 * its code point when it would print as nothing or as blank space (a zero-width space,
 * a tab, a no-break space).
 */
export function displayCharacter(character: string): string {
  return INVISIBLE.test(character)
    ? formatCodePoint(character.codePointAt(0) ?? 0)
    : character;
}
